import {
  GET_ADMIN_SF_FILTERS,
  GET_ADMIN_SF_FILTERS_SUCCESS,
  GET_ADMIN_SF_FILTERS_ERROR,
  CREATE_ADMIN_SF_FILTER,
  CREATE_ADMIN_SF_FILTER_SUCCESS,
  CREATE_ADMIN_SF_FILTER_ERROR,
  UPDATE_ADMIN_SF_FILTER,
  UPDATE_ADMIN_SF_FILTER_SUCCESS,
  UPDATE_ADMIN_SF_FILTER_ERROR,
  DELETE_ADMIN_SF_FILTER,
  DELETE_ADMIN_SF_FILTER_SUCCESS,
  DELETE_ADMIN_SF_FILTER_ERROR,
} from "./actionTypes"
// For get
export const getAdminSfFilters = () => {
  return {
    type: GET_ADMIN_SF_FILTERS,
  }
}

export const getAdminSfFiltersSuccess = (lead_prices) => {
  return {
    type: GET_ADMIN_SF_FILTERS_SUCCESS,
    payload: lead_prices,
  }
}

export const getAdminSfFiltersError = (error) => {
  return {
    type: GET_ADMIN_SF_FILTERS_ERROR,
    payload: error,
  }
}
// For create
export const createAdminSfFilter = (payload) => {
  return {
    type: CREATE_ADMIN_SF_FILTER,
    payload: payload,
  }
}

export const createAdminSfFilterSuccess = (lead_prices) => {
  return {
    type: CREATE_ADMIN_SF_FILTER_SUCCESS,
    payload: lead_prices,
  }
}

export const createAdminSfFilterError = (error) => {
  return {
    type: CREATE_ADMIN_SF_FILTER_ERROR,
    payload: error,
  }
}
// For update
export const updateAdminSfFilter = (payload) => {
  return {
    type: UPDATE_ADMIN_SF_FILTER,
    payload: payload,
  }
}

export const updateAdminSfFilterSuccess = (lead_prices) => {
  return {
    type: UPDATE_ADMIN_SF_FILTER_SUCCESS,
    payload: lead_prices,
  }
}

export const updateAdminSfFilterError = (error) => {
  return {
    type: UPDATE_ADMIN_SF_FILTER_ERROR,
    payload: error,
  }
}
// For delete 
export const deleteAdminSfFilter = (payload) => {
  return {
    type: DELETE_ADMIN_SF_FILTER,
    payload: payload,
  }
}

export const deleteAdminSfFilterSuccess = (lead_prices) => {
  return {
    type: DELETE_ADMIN_SF_FILTER_SUCCESS,
    payload: lead_prices,
  }
}

export const deleteAdminSfFilterError = (error) => {
  return {
    type: DELETE_ADMIN_SF_FILTER_ERROR,
    payload: error,
  }
}


